module.exports = __webpack_public_path__ + "img/1531902282.45dfb195.jpg";